import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const FilterSelectIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M14.79 21.63C13.91 21.71 12.97 21.73 12.04 21.69C11.61 21.65 11.27 21.99 11.26 22.4C11.24 22.81 11.56 23.17 11.97 23.19C12.95 23.24 13.97 23.22 14.93 23.12C15.34 23.08 15.64 22.71 15.61 22.3C15.57 21.89 15.2 21.59 14.79 21.62V21.63Z"
        fill={color}
      />
      <path
        d="M8.40997 21.2C7.43997 20.97 6.55997 20.68 5.85997 20.34C5.48997 20.16 5.03997 20.32 4.85997 20.69C4.67997 21.06 4.83997 21.51 5.20997 21.69C6.01997 22.08 6.97997 22.4 8.05997 22.65C8.44998 22.74 8.86997 22.5 8.95997 22.09C9.04997 21.69 8.79997 21.28 8.39997 21.19L8.40997 21.2Z"
        fill={color}
      />
      <path
        d="M20.43 19.51C19.89 20.05 19.17 20.5 18.28 20.85C17.9 21 17.71 21.44 17.86 21.82C18.01 22.21 18.46 22.39 18.83 22.24C19.91 21.81 20.8 21.25 21.48 20.57C21.8 20.28 21.8 19.8 21.49 19.5C21.2 19.21 20.71 19.22 20.42 19.51H20.43Z"
        fill={color}
      />
      <path
        d="M2.77999 15.5C2.68999 15.1 2.28999 14.85 1.87999 14.94C1.47999 15.03 1.21999 15.44 1.31999 15.84C1.56999 16.92 1.87999 17.88 2.25999 18.7C2.43999 19.08 2.88999 19.24 3.25999 19.06C3.63999 18.89 3.79999 18.44 3.61999 18.06C3.28999 17.35 2.99999 16.47 2.77999 15.5Z"
        fill={color}
      />
      <path
        d="M22.78 13.59C22.63 13.2 22.19 13.0199 21.81 13.1699C21.42 13.3199 21.23 13.76 21.39 14.14C21.73 15.03 21.89 15.79 21.85 16.6C21.82 17.03 22.17 17.3999 22.6 17.3999C22.99 17.3999 23.32 17.1 23.35 16.7C23.41 15.67 23.22 14.6899 22.8 13.59H22.78Z"
        fill={color}
      />
      <path
        d="M2.30002 11.87C2.26002 10.96 2.28002 10.01 2.37002 9.11996C2.41002 8.70996 2.11002 8.33996 1.70002 8.29996C1.29002 8.25996 0.920016 8.55996 0.880016 8.96996C0.780016 9.91996 0.760016 10.95 0.800016 11.93C0.820016 12.34 1.17002 12.67 1.58002 12.65C1.99002 12.63 2.32002 12.28 2.30002 11.87Z"
        fill={color}
      />
      <path
        d="M19.56 11.04C19.81 11.37 20.28 11.44 20.61 11.19C20.94 10.94 21.01 10.47 20.76 10.14C20.51 9.81 20.24 9.46 19.94 9.11L22.52 6.53C22.66 6.39 22.74 6.2 22.74 6V4C22.74 3.59 22.4 3.25 21.99 3.25H7C6.59 3.25 6.25 3.59 6.25 4V6C6.25 6.2 6.33 6.39 6.47 6.53L12.25 12.31V19C12.25 19.24 12.36 19.46 12.56 19.61C12.69 19.7 12.85 19.75 13 19.75C13.08 19.75 13.15 19.74 13.23 19.71L16.23 18.75C16.54 18.65 16.75 18.36 16.75 18.04V12.31L18.88 10.18C19.12 10.47 19.35 10.76 19.56 11.04ZM15.47 11.47C15.33 11.61 15.25 11.8 15.25 12V17.49L13.75 17.97V12C13.75 11.8 13.67 11.61 13.53 11.47L7.75 5.69V4.75H21.25V5.69L15.47 11.47Z"
        fill={color}
      />
      <path
        d="M3.50003 2.44002C2.79003 3.13002 2.23003 4.00002 1.79003 5.07002C1.63003 5.45002 1.82003 5.89002 2.20003 6.05002C2.57003 6.21002 3.02003 6.03002 3.18003 5.64002C3.53003 4.79002 3.97003 4.09002 4.55003 3.51002C4.85003 3.22002 4.85003 2.75002 4.56003 2.45002C4.27003 2.15002 3.80003 2.15002 3.50003 2.44002Z"
        fill={color}
      />
      <path
        d="M7.43999 2.16C8.19999 2.12 9.01999 2.28 9.89999 2.64C10.27 2.79 10.72 2.61 10.87 2.22C11.02 1.84 10.84 1.4 10.45 1.25C9.35999 0.819996 8.32999 0.619996 7.34999 0.669996C6.93999 0.689996 6.61999 1.04 6.63999 1.46C6.65999 1.87 6.99999 2.18 7.42999 2.17L7.43999 2.16Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

FilterSelectIcon.displayName = 'FilterSelectIcon';
